import { Injectable } from '@angular/core';
import { Storage, Util } from './../../shared/index';
import { ConfigService } from './config.service';
declare var Promise: any;

@Injectable()
export class BaseService {

    public settings: any;
    public credentials: any = {};
    public saveLocalModel = Storage.saveLocalModel;
    public restoreLocalModel = Storage.restoreLocalModel;
    public isOnline = Util.isOnline;

    constructor(public config: ConfigService  ) {
        this.settings = this.config['_config'];
    }

    public async fetchCredentials(url) {
        const self = this;
        let result =  await fetch(url)
            .then(function(response) {
                return response.json();
            })
            .catch(function(error) {
                console.log('credentials fetch error:', error.message);
            });
        Object.keys(result.credentials).forEach(function (key) {
            self.credentials[key] = result.credentials[key];
        });
        return self.credentials;
    }

}

